import { isEmpty } from 'lodash';
import { companySummaryUrl } from 'common/config/urls';
import { FirmAndCompanyProps, GetBreadcrumbsParams } from './getBreadcrumbs.props';

export const getBreadcrumbs = ({
  firmInfo,
  companyInfo,
  breadcrumbsTitle,
  extraBreadcrumbs,
}: GetBreadcrumbsParams) => {
  const getCompanyURL = ({ firmData, companyData }: FirmAndCompanyProps) => {
    if (isEmpty(firmData) || isEmpty(companyData)) {
      return '';
    }

    if (firmData.slug && companyData.slug) {
      return companySummaryUrl(firmData.slug, companyData.slug);
    }

    return '';
  };

  const breadcrumbs = () => [
    {
      title: companyInfo.name,
      url: getCompanyURL({ firmData: firmInfo, companyData: companyInfo }),
    },
    {
      title: breadcrumbsTitle,
    },
    ...(extraBreadcrumbs || []),
  ];

  return breadcrumbs();
};

export default getBreadcrumbs;
